// extracted by css-extract-rspack-plugin
export default {"bool-group":"bool-group-LG2oVz","boolGroup":"bool-group-LG2oVz"};